var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.selectedOrder
        ? _c("order-detail", {
            attrs: { order: _vm.selectedOrder },
            on: { close: _vm.close, update: _vm.updateOrder }
          })
        : _c(
            "table",
            { staticClass: "w-full divide-y divide-gray-300 table-fixed mt-2" },
            [
              _c("thead", { staticClass: "bg-gray-50" }, [
                _c("tr", [
                  _c(
                    "th",
                    {
                      staticClass:
                        "w-[15%] py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6",
                      attrs: { scope: "col" }
                    },
                    [_vm._v("\n          Číslo objednávky\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass:
                        "w-[10%] px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
                      attrs: { scope: "col" }
                    },
                    [_vm._v("\n          Datum\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass:
                        "w-[55%] px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
                      attrs: { scope: "col" }
                    },
                    [_vm._v("\n          Produkty\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass:
                        "w-[10%] px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
                      attrs: { scope: "col" }
                    },
                    [_vm._v("\n          Cena\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "th",
                    {
                      staticClass:
                        "w-[10%] px-3 py-3.5 text-left text-sm font-semibold text-gray-900",
                      attrs: { scope: "col" }
                    },
                    [_vm._v("\n          Stav\n        ")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                { staticClass: "divide-y divide-gray-200 bg-white" },
                _vm._l(_vm.localOrders, function(order, index) {
                  return _c(
                    "tr",
                    {
                      key: order.id,
                      staticClass:
                        "cursor-pointer hover:text-brandRed text-gray-500",
                      class: index % 2 === 0 ? "" : "bg-gray-50",
                      on: {
                        click: function($event) {
                          _vm.selectedOrder = order
                        }
                      }
                    },
                    [
                      _c(
                        "td",
                        {
                          staticClass:
                            "py-4 pl-4 pr-3 text-sm font-black sm:pl-6"
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(order.id) + "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("td", { staticClass: "px-3 py-4 text-sm" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatDate(order.date_created.date)) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "px-3 py-4 text-sm truncate" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.products(order.line_items)) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "px-3 py-4 text-sm" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.total(order.total, order.currency)) +
                            "\n        "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "px-3 py-4 text-sm" },
                        [_c("order-status", { attrs: { slug: order.status } })],
                        1
                      )
                    ]
                  )
                }),
                0
              )
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/matej/Works/Code/mago/wp-content/themes/sage/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/matej/Works/Code/mago/wp-content/themes/sage/node_modules/vue-loader/lib?{}!./scripts/vue/auth/partials/OrdersTable.vue?vue&type=template&id=42daccef&
// module id = 180
// module chunks = 0